<template>

  <v-app dark>
    <v-main>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="success"
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="py-0 pt-3 ">
                <v-alert v-if="error" type="error">
                  {{ error }}
                </v-alert>
                <v-form>
                  <v-text-field
                    class="py-2 px-2"
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account-lock"
                    type="text"
                    v-model="usuario.login"
                    v-lowercase-only
                  ></v-text-field>
              
                  <v-text-field
                    class="py-2 px-2"
                    id="password"
                    label="Senha"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="usuario.senha"
                    v-on:keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="pr-2 pb-2">
                <v-spacer></v-spacer>
                <v-btn color="success" @click="login" :loading="isLoading" min-width="90">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
  
</template>

<script>

export default {
  name: 'Login',
  data () {
    return {
      usuario: {
        login: '',
        senha: ''
      },
      isLoading: false,
      error: null,
    }
  },
  methods: {
    login: function () {
      this.error = null
      let user = {
        'ds_email': this.usuario.login,
        'password': this.usuario.senha
      }
      this.isLoading = true
      this.$store.dispatch('login/auth_request', { user })
      .then(response => {
        if (response.data.status) {
          this.$router.push({path: '/'})
        } else if (response.data.validacao == true) {
          let errosStr = ''
          let obj = response.data.erros
          if (Object.keys(obj).length) {
            Object.keys(obj).forEach(function (item) {
              errosStr += obj[item] + ', '
            })
            this.error = errosStr
          }
        } else {
          this.error = response.data.error
        }
      })
      .catch(e => {
        console.log(e)
        alert('Erro! Tente novamente mais tarde...')
      })
      .finally(() => this.isLoading = false)
    }
  }
}


</script>

 <style scoped>
 </style>


// WEBPACK FOOTER //
// src/views/Login/Login.vue